import { HFormat, MyUI } from "@macashipo/mlib"
import React from "react"
import styled from "styled-components"

const Wrap = styled.div`
  width: 100%;
  display: grid;
  gap: 10px 1%;
`
export default function MUIGrid(props) {
  const { data, typeItem, numCol } = props
  let _templateColumns = ""
  let _numCol = HFormat.format(numCol, {
    type: "numColByWidth",
    defaultValue: 5,
  })
  for (let i = 0; i < _numCol; i++) {
    _templateColumns += "1fr"
    if (i < _numCol - 1) {
      _templateColumns += " "
    }
  }
  // console.warn("render grid:", _numCol, _templateColumns)
  return (
    <Wrap
      className="mui-grid"
      style={{ gridTemplateColumns: _templateColumns }}
    >
      {data &&
        data.length > 0 &&
        data.map((v, i) => {
          return (
            <MyUI
              key={i}
              type={typeItem}
              data={v}
              configItem={props.configItem}
              fnList={props.fnList}
            />
          )
        })}
    </Wrap>
  )
}
